import React, {useState} from 'react';
import PropTypes from 'prop-types';

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

import './CustomTimePicker.scss';

CustomTimePicker.propTypes = {
  selectedTime: PropTypes.any
};

export default function CustomTimePicker(props) {
  const {
    appointmentStartTimes,
    onTimeChange,
    isLoading,
    timezone,
  } = props;

  const [selectedTime, setSelectedTime] = useState(props.selectedTime || null);

  return (
    <Stack direction='column' gap={3} className='CustomTimePicker'>
      <Grid container spacing={0.75} className="time-grid">
        {(!appointmentStartTimes || !appointmentStartTimes.length) && !isLoading
          ?
          <Grid item xs={12}>
            <Stack direction='row' justifyContent='center' padding={3}>
              <Typography variant='subtitle1'>
                No times available on this day.
              </Typography>
            </Stack>
          </Grid>
          : null
        }
        {appointmentStartTimes?.map(t =>
          <Grid item xs={3}>
            <Box
              className={`time-item ${t === selectedTime && 'time-item--selected'}`}
              onClick={() => handleTimeChange({setSelectedTime, onTimeChange})(t)}
            >
              <Typography className={`time-item__text ${t === selectedTime && 'time-item__text--selected'}`} align='center' noWrap>
                {t}
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </Stack>
  );
}

const handleTimeChange = ({setSelectedTime, onTimeChange}) => time => {
  setSelectedTime(time);
  onTimeChange(time);
};

const handleDateSelect = ({onDateChange}) => dateObj => {
  onDateChange(dateObj);
};
